(() => {
  const initFooter = (footer) => {
    if (footer.dataset.initialized === 'true') return;
    footer.dataset.initialized = 'true';

    const accordions = footer.querySelectorAll('.pf__accordion');
    let wasDesktop;

    const syncAccordions = () => {
      const isDesktop = window.matchMedia('(min-width: 900px)').matches;

      if (isDesktop) {
        accordions.forEach((accordion) => {
          accordion.open = true;
        });
      } else if (wasDesktop !== false) {
        accordions.forEach((accordion, index) => {
          accordion.open = index === 0;
        });
      }

      wasDesktop = isDesktop;
    };

    syncAccordions();
    window.addEventListener('resize', syncAccordions, { passive: true });

    if (!('IntersectionObserver' in window)) {
      footer.classList.add('pf--visible');
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        footer.classList.add('pf--visible');
        observer.disconnect();
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    observer.observe(footer);
  };

  const initAll = () => {
    document.querySelectorAll('[data-premium-footer]').forEach(initFooter);
  };

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
